<template>
  <div>

    <!-- Modal para ver detalles -->
    <b-modal id="bv-modal-details-nu-gres" hide-footer size="xl" scrollable>
      <template #modal-title>
        Guía de respuestas a emergencias - Detalles
      </template>

      <div class="d-flex justify-content-end align-items-center d-flex-grap mb-2">
        <b-button id="show-btn" @click="onHandleOpenModalToCreateNewDetail()" variant="primary"><i
            class="fa fa-plus mr-1"></i> Agregar</b-button>
      </div>

      <b-table :bordered="true" :borderless="true" :outlined="true" :hover="true" :fixed="true" :no-border-collapse="true"
        table-variant="white" :fields="tableConfig.fieldsDetails" :items="detailsOfGuide.data" responsive="sm">

        <!-- Columna campo personalizado -->
        <template #cell(custom_field)="data">
          <div
            v-if="data.item.custom_field_nu_gre && typeof data.item.custom_field_nu_gre === 'object' && 'label' in data.item.custom_field_nu_gre">
            <el-tooltip
              :content="`${data.item.custom_field_nu_gre.is_active ? data.item.custom_field_nu_gre.label : 'Campo personalizado Inactivo'}`"
              placement="bottom" effect="light">
              <span :class="`${data.item.custom_field_nu_gre.is_active ? 'text-black' : 'text-danger'}`">{{
                data.item.custom_field_nu_gre.label }}</span>
            </el-tooltip>
          </div>
          <div v-else>
            N/A
          </div>
        </template>

        <!-- Columna de Estado del item -->
        <template #cell(is_active)="data">
          <div v-if="data.item.is_active"><span class="badge badge-primary">ACTIVO</span></div>
          <div v-else><span class="badge badge-light">INACTIVO</span></div>
        </template>

        <!-- Columna acciones -->
        <template #cell(actions)="data">
          <div class="d-flex justify-content-start align-items-center">
            <el-tooltip content="Editar" placement="bottom" effect="light">
              <el-button type="text" size="medium" class="text-primary" @click="onHandleEdit(data.item)">
                <i class="fa fa-edit" />
              </el-button>
            </el-tooltip>
            <el-tooltip class="ml-2" :content="data.item.is_active ? 'INACTIVAR' : 'ACTIVAR'" placement="bottom"
              effect="light">
              <el-button type="text" size="medium" :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`"
                @click="onHandleChangeStatus(data.item)">
                <i :class="`fa ${data.item.is_active ? 'fa-close' : 'fa-check'}`" />
              </el-button>
            </el-tooltip>
          </div>
        </template>

      </b-table>

      <!-- Validaciones e información -->
      <div>
        <div v-if="tableConfig.dataFieldsDetails.total <= 0" class="text-center w-100 p-4">
          <div class="text-center">
            <i class="d-block fa fa-tasks mr-1 icon-list-empty"></i>
            <small>No hay datos para mostrar...</small>
          </div>
        </div>
      </div>

      <!-- Paginación -->
      <div>
        <div class="d-flex justify-content-end align-items-center pr-4 mt-4">

          <el-pagination :total="tableConfig.dataFieldsDetails.total" v-model="tableConfig.dataFieldsDetails.page"
            :current-page="tableConfig.dataFieldsDetails.page" :page-sizes="[10, 20, 30, 100]"
            :page-size="tableConfig.dataFieldsDetails.per_page" layout="total, sizes, prev, pager, next"
            @size-change="loadAfterChangeSizePagination" @current-change="loadAfterChangePagePagination" />

        </div>
        <br />
      </div>

    </b-modal>

  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from "vuex";

// Componentes
import Swal from 'sweetalert2';

export default {
  name: "ConfigNuGreComponent",
  computed: {
    // Estados para el modulo del Naciones unidas - gre
    ...mapState("NuGreAdmin", [
      'tableConfig',
      'detailsOfGuide',
      'currentNuGreActive'
    ]),
  },
  methods: {
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapActions("NuGreAdmin", ['getDetailsByEmergencyResponseGuide', 'update']),
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapMutations("NuGreAdmin", [
      'setTableConfigPaginationGuidesDetails',
      'setTableConfigPagination',
      'setCurrentNuGreActive',
      'resetDetailsNuGres',
      'setAction',
      'setUseSelectNuGreInFrom',
      'setCurrentDetailsNuGre'
    ]),
    /**
     * Cambiar la cantidad de ítems por página en la paginación.
     * 
     * @author Fernando Claros
     */
    loadAfterChangeSizePagination(per_page = 10) {
      this.setTableConfigPaginationGuidesDetails({ ...this.tableConfig.dataFieldsDetails, per_page, page: 1 });
      this.load();
    },
    /**
     * Cambiar entre páginas en la paginación.
     * 
     * @author Fernando Claros
     */
    loadAfterChangePagePagination(page = 1) {
      this.setTableConfigPaginationGuidesDetails({ ...this.tableConfig.dataFieldsDetails, page });
      this.load();
    },
    /**
     * Recargar el listado cuando hay afectaciones en la paginación.
     * 
     * @author Fernando Claros
     */
    async load() {
      await this.getDetailsByEmergencyResponseGuide({
        id: this.currentNuGreActive,
        page: this.tableConfig.dataFieldsDetails.page,
        per_page: this.tableConfig.dataFieldsDetails.per_page
      });
    },
    /**
     * Abrir modal para crear nuevos detalles a un NU - GRE.
     * @author Fernando Claros
     */
    onHandleOpenModalToCreateNewDetail() {
      this.resetDetailsNuGres();
      this.setAction('CREATE');
      this.setUseSelectNuGreInFrom(false);
      this.$bvModal.show('bv-modal-manage-config-nu-gres')
    },
    /**
     * Cambiar estado de un detalle.
     * @author Fernando Claros
     */
    onHandleChangeStatus(item) {

      const payload = {
        id: item.id,
        description: item.description,
        slq_custom_field_nu_gre_id: item.slq_custom_field_nu_gre_id,
        is_active: !item.is_active,
        slq_emergency_response_guide_id: item.slq_emergency_response_guide_id
      };

      const action = item.is_active ? 'inactivar' : 'activar'

      Swal.fire({
        icon: "warning",
        title: "Guías de emergencias",
        text: `¿Está seguro que desea ${action} el detalle de la guía?.`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `Si, ${action}!`,
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.isConfirmed) await this.update(payload);
      });

    },
    /**
     * Abrir modal para editar el detalle.
     * @author Fernando Claros
     */
    onHandleEdit(item) {

      this.resetDetailsNuGres();
      this.setAction('EDIT');
      this.setUseSelectNuGreInFrom(false);
      this.setCurrentDetailsNuGre(item);
      this.$bvModal.show('bv-modal-manage-config-nu-gres')

    }
  }
};
</script>

<style scoped>
.icon-list-empty {
  font-size: 40px;
}</style>
